































import { Component, Vue } from 'vue-property-decorator';
import WarehouseProuductReport from './Warehouse/WarehouseProductReport.vue';

@Component({
  components: {
    WarehouseProuductReport,
  },
})
export default class Warehouse extends Vue {}
